package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.AlertDialogDefaults
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.layout.heightAboveKeyboard
import com.eladfinish.bible.contest.ui.layout.isKeyboardCoveringShortWindow

/**
 * An AlertDialog whose content holds text fields. While the keyboard covers a short window only the
 * content is left, with its fields: AlertDialog's own title, buttons and margins would not leave them any
 * height. The same layout stays in the composition either way, or the focused field, and with it the
 * keyboard, would be lost when the dialog changes.
 */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TextInputAlertDialog(
    title: String,
    onDismissRequest: () -> Unit,
    buttons: @Composable RowScope.() -> Unit,
    content: @Composable ColumnScope.() -> Unit,
) {
    val isTyping = isKeyboardCoveringShortWindow()
    BasicAlertDialog(
        onDismissRequest = onDismissRequest,
        modifier = Modifier.heightAboveKeyboard(),
    ) {
        Surface(
            shape = AlertDialogDefaults.shape,
            color = AlertDialogDefaults.containerColor,
            tonalElevation = AlertDialogDefaults.TonalElevation,
        ) {
            Column(modifier = Modifier.padding(if (isTyping) 8.dp else 24.dp)) {
                if (!isTyping) {
                    Text(
                        text = title,
                        style = MaterialTheme.typography.headlineSmall,
                        modifier = Modifier.padding(bottom = 16.dp),
                    )
                }
                CompositionLocalProvider(LocalContentColor provides AlertDialogDefaults.textContentColor) {
                    Column(
                        modifier = Modifier
                            .weight(1f, fill = false)
                            .verticalScroll(rememberScrollState()),
                        content = content,
                    )
                }
                if (!isTyping) {
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 24.dp),
                        horizontalArrangement = Arrangement.spacedBy(8.dp, Alignment.End),
                        content = buttons,
                    )
                }
            }
        }
    }
}
